/**
 * created by lei lei
 *
 //页面引入组件，下面写法
 <TiktokReview ref={(TiktokReview)=>{this.TiktokReview=TiktokReview}}/>
 //预览方法
 let reviewParms={
                title : record.title,//标题
                titlePic : record.coverUrl,//封面图
                updateDate : record.updateDate,//更新时间
                author : record.user,//发布者
                videoUrl:record.videoUrl,//视频地址
            }
 this.TiktokReview.show(reviewParms)//调用方法
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Button, Modal} from "antd";
import * as Utils from "../../../utils";
import ContentModal from "../../../containers/contentModal";
import {Scrollbars} from "react-custom-scrollbars";
import {UserOutlined} from "@ant-design/icons";
import  *as utils from'../../../utils/index'

export default class TiktokReview extends Component {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            tiktokStatus:false,
            title : '',
            titlePic : '',
            summary : '',
            content : '',
            updateDate : '',
            author : '',
            videoUrl:'',
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {
        return (
            <div>
                <Modal key={Utils.uuid()} title={"内容详情"} visible={this.state.tiktokStatus} 
                       onCancel={() => {
                           this.setState({tiktokStatus: false})
                       }} footer={
                    this.state.videoShareUrl ?
                        <Button type="primary" onClick={() => {
                            window.open(this.state.videoShareUrl)
                        }}> 查看原抖音</Button> : null

                }>
                    <Scrollbars  autoHide autoHeight autoHeightMax={'40vh'}>
                       <div style={{padding:"15px"}}>
                           <span>{this.state.updateDate}</span>
                           <div dangerouslySetInnerHTML={{__html: this.state.title}}></div>
                           {/*  <div style={{padding: "10px 0"}}>

                              <div style={{textAlign:'center'}} key={utils.uuid()}>
                                    <iframe src={'./tiktokReview/preview.html?videoUrl=' + this.state.videoUrl}
                                            height={570} frameBorder="0"></iframe>
                                </div>
                            </div>*/}
                        </div>
                    </Scrollbars>
                </Modal>
            </div>
        )
    }
    show(record,signWords){
        let title;
        if (signWords.length > 0) {
            title = Utils.filtion(signWords, "<div>" + record.title + "</div>").value;
        }else{
            title ="<div>" + record.title + "</div>";

        }

        this.setState({
            tiktokStatus: true,
          ...record,
            title,
        })
    }

}